/**
 * Appends array-based query parameters to the given base URI.
 *
 * This function takes a base URI and an object containing key-value pairs where the values are arrays.
 * Each element in the array is appended as individual query parameters with the corresponding key to the base URI.
 *
 * @param {string} baseUri - The base URI to which query parameters will be appended.
 * @param {Record<string, (string | number | boolean)[]>} params - An object containing keys and array of values to be added as query parameters.
 * Each key in the object is used as a query parameter name, and each value in the corresponding array is appended as a separate occurrence of the parameter.
 * @returns {string} - The modified URI with the appended query parameters as a string.
 */
const addArrayQueryParams = function (baseUri: string, params: Record<string, (string | number | boolean)[]>): string {
    const url = new URL(baseUri);

    Object.entries(params).forEach(([key, values]) => {
        values.forEach(value => {
            url.searchParams.append(key, value.toString());
        });
    });

    return url.toString();
}


export default addArrayQueryParams;